import React from 'react'

import { StyledBadge, StyledStatusContainer } from './PreviewStatusStyled'

interface PreviewStatusProps {
  badgeColor?: string
  statusLabel?: string
}

const PreviewStatus: React.FC<PreviewStatusProps> = ({
  badgeColor,
  statusLabel,
}) => (
  <StyledStatusContainer>
    <StyledBadge $color={badgeColor} />
    {statusLabel}
  </StyledStatusContainer>
)

export default PreviewStatus
